// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3bsIk","header":"MessagesList_header__2OhhF","chat":"MessagesList_chat__mA_eK"};